import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BirthdayPoster from './BirthdayPoster';
import EventsCalendar from '../Dashbord/EventsCalendar';
import logo from '../Header/Images/RMB-Strip-Jaipur.png';
import mainLogo from '../Header/Images/logo.png';
import ReportsAnalytics from '../Dashbord/Reports/ReportsAnalytics';
import { 
  FaUserCheck, FaHandshake, FaFileInvoiceDollar, FaUserPlus, 
  FaCalendarAlt, FaKey, FaBuilding, FaCreditCard, FaShieldAlt, 
  FaEye, FaEyeSlash, FaPlus, FaHistory, FaCheckCircle, 
  FaClock, FaTimesCircle, FaSave, FaAward, FaCalendarCheck, FaImage, 
  FaCommentDots, FaHeart, FaTimes, FaLock, FaUpload, FaGlobe, FaMapMarkerAlt, FaGlobeAmericas,
  FaChartBar, FaBell, FaGift, FaBriefcase, FaFileAlt, FaUser, FaThLarge, FaChevronRight, FaChevronLeft,
  FaStar, FaSignOutAlt, FaQuestionCircle, FaCog, FaUsers
} from 'react-icons/fa';

interface UserDetails {
  id: number;
  name: string;
  email: string;
  role: string;
  sub_role?: string;
  permissions?: any;
  company_name?: string;
  designation?: string;
  company_address?: string;
  company_website?: string;
  about_company?: string;
  social?: string;
  profile?: string;
  DOB?: string;
  Time?: string;
  expire?: string;
  number?: string;
  password?: string;
  plain_password?: string;
  status?: string;
  payment_details?: string;
  point?: number;
}

interface Activity {
  id: number;
  type: string;
  giver_id: number;
  giver_name?: string;
  receiver_id?: number;
  receiver_name?: string;
  ref_person_name?: string;
  number?: string;
  amount?: number;
  details?: string;
  image?: string;
  status: string;
  points_awarded: number;
  date: string;
}

interface AuditItem {
  id: number;
  action_type: string;
  joining_date?: string;
  renewal_date: string;
  next_expiry_date: string;
  amount_paid: number;
  payment_mode: string;
  payment_reference?: string;
  notes?: string;
}

const MemberPortal = () => {
  const [userId, setUserId] = useState<number | null>(null);
  const navigate = useNavigate();
  const [userdetails, setUserdetails] = useState<UserDetails | null>(null);
  const [activeTab, setActiveTab] = useState('Dashboard');
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  const [theme, setTheme] = useState<'dark' | 'light'>(() => {
    return (localStorage.getItem('APP_THEME') as 'dark' | 'light') || 'dark';
  });

  const toggleTheme = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    setTheme(next);
    localStorage.setItem('APP_THEME', next);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('isImpersonating');
    navigate('/login');
  };

  // Dashboard Stats
  const [metrics, setMetrics] = useState({
    presence: 0,
    businessGive: 0,
    businessGiveCount: 0,
    businessReceive: 0,
    businessReceiveCount: 0,
    r2rCount: 0,
    referralCount: 0,
    visitorCount: 0
  });

  const [nextEventTitle, setNextEventTitle] = useState('Next Meeting - RMB Jaipur Chapter');
  const [textNewsHeading, setTextNewsHeading] = useState<string>('');

  useEffect(() => {
    axios.get('https://rmbbackend.rmbjaipur.com/auth/newsheading')
      .then(res => {
        if (res.data?.data?.[0]?.title) {
          setTextNewsHeading(res.data.data[0].title);
        }
      })
      .catch(err => console.error('Error fetching text news in Member Portal:', err));
  }, []);

  // Profile Form State
  const [showPassword, setShowPassword] = useState(false);
  const [showProfilePassword, setShowProfilePassword] = useState(false);
  const [profileForm, setProfileForm] = useState<any>({});
  const [profileUploading, setProfileUploading] = useState(false);

  // My Activities & Audit Trail
  const [myActivities, setMyActivities] = useState<Activity[]>([]);
  const [myAuditLogs, setMyAuditLogs] = useState<AuditItem[]>([]);
  const [allMembers, setAllMembers] = useState<any[]>([]);
  const [createdEventsList, setCreatedEventsList] = useState<any[]>([]);

  // Member Notifications State & Drawer
  const [notifications, setNotifications] = useState<any[]>([]);
  const [unreadCount, setUnreadCount] = useState<number>(0);
  const [showNotifDrawer, setShowNotifDrawer] = useState<boolean>(false);

  const fetchMemberNotifications = async () => {
    try {
      const res = await axios.get('https://rmbbackend.rmbjaipur.com/auth/member/notifications', { withCredentials: true });
      if (res.data?.success) {
        setNotifications(res.data.data || []);
        setUnreadCount(res.data.unreadCount || 0);
      }
    } catch (err) {
      console.error('Error fetching member notifications:', err);
    }
  };

  const handleMarkNotificationsRead = async () => {
    try {
      await axios.post('https://rmbbackend.rmbjaipur.com/auth/member/notifications/mark-read');
      setUnreadCount(0);
      fetchMemberNotifications();
    } catch (err) {
      console.error('Error marking notifications read:', err);
    }
  };

  const handleClearNotifications = async () => {
    try {
      await axios.post('https://rmbbackend.rmbjaipur.com/auth/member/notifications/clear');
      setNotifications([]);
      setUnreadCount(0);
    } catch (err) {
      console.error('Error clearing notifications:', err);
    }
  };

  // Punch Activity Form & Modal State
  const [showPunchModal, setShowPunchModal] = useState<boolean>(false);
  const [punchType, setPunchType] = useState<'R2R' | 'BUSINESS' | 'REFERRAL' | 'VISITOR' | 'TESTIMONIAL' | 'THANK_YOU' | 'ATTENDANCE'>('R2R');
  const [selectedClosedBusinessId, setSelectedClosedBusinessId] = useState<string>('');

  // Reset Password Modal State
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const [newMemberPassword, setNewMemberPassword] = useState('');
  const [confirmMemberPassword, setConfirmMemberPassword] = useState('');
  const [resetPasswordLoading, setResetPasswordLoading] = useState(false);
  const [resetPasswordMessage, setResetPasswordMessage] = useState({ type: '', text: '' });
  const [punchForm, setPunchForm] = useState<any>({
    receiver_id: '',
    ref_person_name: '',
    number: '',
    amount: '',
    details: '',
    image: '',
    date: new Date().toISOString().split('T')[0],
    location: ''
  });

  const formatDateForInput = (dateStr?: string): string => {
    if (!dateStr) return '';
    try {
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return '';
      return d.toISOString().split('T')[0];
    } catch {
      return '';
    }
  };

  const formatDateDisplay = (dateStr?: string): string => {
    if (!dateStr) return 'N/A';
    try {
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return 'N/A';
      return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
    } catch {
      return 'N/A';
    }
  };

  const fetchSessionAndData = async () => {
    try {
      const response = await axios.get('https://rmbbackend.rmbjaipur.com/auth/memberLoggedIn', {
        withCredentials: true,
      });
      
      const loggedUser = response.data?.user || response.data?.data;
      let uid = loggedUser?.id;

      if (!uid) {
        const impersonated = localStorage.getItem('impersonatedUser');
        if (impersonated) {
          try {
            uid = JSON.parse(impersonated).id;
          } catch {}
        }
      }

      if (!uid) {
        console.error('No logged in user found for member portal');
        navigate('/login');
        return;
      }

      setUserId(uid);

      const userResponse = await axios.get(`https://rmbbackend.rmbjaipur.com/auth/user/${uid}`, {
        withCredentials: true,
      });
      const uData = Array.isArray(userResponse.data) ? userResponse.data[0] : userResponse.data;
      setUserdetails(uData);
      setProfileForm({
        name: uData.name || '',
        email: uData.email || '',
        password: uData.plain_password || uData.password || '',
        number: uData.number || '',
        DOB: formatDateForInput(uData.DOB),
        Time: formatDateForInput(uData.Time),
        expire: formatDateForInput(uData.expire),
        role: uData.role || 'member',
        sub_role: uData.sub_role || '',
        company_name: uData.company_name || '',
        designation: uData.designation || 'RMBian',
        company_address: uData.company_address || '',
        company_website: uData.company_website || '',
        about_company: uData.about_company || '',
        social: uData.social || '',
        status: uData.status || 'active',
        payment_details: uData.payment_details || '',
        profile: uData.profile || ''
      });

      // Fetch user's own activities & calculate metric cards
      try {
        const actRes = await axios.get(`https://rmbbackend.rmbjaipur.com/auth/activities`);
        const userActs: Activity[] = (actRes.data.activities || []).filter((a: any) => a.giver_id === uid || a.receiver_id === uid);
        setMyActivities(userActs);

        let r2r = 0, ref = 0, vis = 0, bGive = 0, bGiveAmt = 0, bRec = 0, bRecAmt = 0;
        userActs.forEach(a => {
          if (a.type === 'R2R') r2r++;
          if (a.type === 'REFERRAL') ref++;
          if (a.type === 'VISITOR_INVITE') vis++;
          if (a.type === 'BUSINESS_ACK') {
            if (a.giver_id === uid) {
              bGive++;
              bGiveAmt += Number(a.amount || 0);
            } else {
              bRec++;
              bRecAmt += Number(a.amount || 0);
            }
          }
        });

        setMetrics({
          presence: 0,
          businessGive: bGiveAmt,
          businessGiveCount: bGive,
          businessReceive: bRecAmt,
          businessReceiveCount: bRec,
          r2rCount: r2r,
          referralCount: ref,
          visitorCount: vis
        });
      } catch (e) {
        console.error('Error fetching member activities:', e);
      }

      // Fetch user's own audit trail
      try {
        const auditRes = await axios.get(`https://rmbbackend.rmbjaipur.com/auth/membership/audit-trail`, {
          params: { user_id: uid }
        });
        setMyAuditLogs(auditRes.data.audit_trail || []);
      } catch (e) {
        console.error('Error fetching member audit trail:', e);
      }

      // Fetch upcoming events to populate Next Event Banner
      try {
        const evRes = await axios.get(`https://rmbbackend.rmbjaipur.com/auth/events`);
        const evList = Array.isArray(evRes.data) ? evRes.data : (evRes.data?.events || []);
        if (Array.isArray(evList) && evList.length > 0) {
          const upcoming = evList[0];
          setNextEventTitle(`Title: ${upcoming.event_type || 'RMB Event'} - ${upcoming.location || 'Jaipur'} (${upcoming.event_date || upcoming.date || ''})`);
        }
      } catch (e) {
        console.error('Error fetching member events:', e);
      }

    } catch (error: any) {
      console.error('Session validation failed:', error);
      navigate('/login');
    }
  };

  const fetchAllMembers = async () => {
    try {
      const res = await axios.get('https://rmbbackend.rmbjaipur.com/auth/allusersinfo');
      const list = Array.isArray(res.data) ? res.data : (res.data.data || []);
      const activeList = list.filter((u: any) => (
        u.delete !== 1 && 
        u.role !== 'super-admin' && 
        (u.status === 'active' || !u.status)
      ));
      activeList.sort((a: any, b: any) => (a.name || '').localeCompare(b.name || ''));
      setAllMembers(activeList);
    } catch (err) {
      console.error('Error fetching members:', err);
    }
  };

  const fetchCreatedEventsList = async () => {
    try {
      const res = await axios.get('https://rmbbackend.rmbjaipur.com/auth/news');
      if (Array.isArray(res.data)) {
        setCreatedEventsList(res.data);
      }
    } catch (err) {
      console.error('Error fetching created events list from news:', err);
    }
  };

  useEffect(() => {
    fetchSessionAndData();
    fetchAllMembers();
    fetchCreatedEventsList();
    fetchMemberNotifications();
  }, [navigate]);

  const handleProfileSave = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!userId) return;
    try {
      await axios.put(`https://rmbbackend.rmbjaipur.com/auth/users/${userId}/update`, profileForm);
      alert('Your Profile & Company details updated successfully!');
      fetchSessionAndData();
    } catch (err) {
      console.error('Error updating profile:', err);
      alert('Failed to update profile.');
    }
  };

  const openPunchModal = (type: 'R2R' | 'BUSINESS' | 'REFERRAL' | 'VISITOR' | 'TESTIMONIAL' | 'THANK_YOU' | 'ATTENDANCE') => {
    setPunchType(type);
    setSelectedClosedBusinessId('');
    setPunchForm({
      receiver_id: '',
      ref_person_name: '',
      number: '',
      amount: '',
      details: '',
      image: '',
      date: new Date().toISOString().split('T')[0],
      location: ''
    });
    setShowPunchModal(true);
  };

  const [isUploading, setIsUploading] = useState(false);

  const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('image', file);

    try {
      setIsUploading(true);
      const res = await axios.post('https://rmbbackend.rmbjaipur.com/auth/upload-image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setPunchForm((prev: any) => ({ ...prev, image: res.data.imagePath }));
    } catch (err) {
      console.error('Image upload failed:', err);
      alert('Failed to upload image file.');
    } finally {
      setIsUploading(false);
    }
  };

  const handleProfilePhotoChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('image', file);

    try {
      setProfileUploading(true);
      const res = await axios.post('https://rmbbackend.rmbjaipur.com/auth/upload-image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setProfileForm((prev: any) => ({ ...prev, profile: res.data.imagePath }));
    } catch (err) {
      console.error('Profile photo upload failed:', err);
      alert('Failed to upload profile picture.');
    } finally {
      setProfileUploading(false);
    }
  };

  const handlePunchSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!userId) return;

    let apiType = 'R2R';
    if (punchType === 'R2R') apiType = 'R2R';
    if (punchType === 'BUSINESS') apiType = 'BUSINESS_ACK';
    if (punchType === 'REFERRAL') apiType = 'REFERRAL';
    if (punchType === 'VISITOR') apiType = 'VISITOR_INVITE';
    if (punchType === 'TESTIMONIAL') apiType = 'TESTIMONIAL';
    // Image is optional for R2R and Business Closed submissions
    if (punchType === 'TESTIMONIAL' && !punchForm.receiver_id) {
      alert('⚠️ Testimonials can only be given against a closed business transaction where you were the Giver.');
      return;
    }

    if (punchType === 'THANK_YOU' && !punchForm.receiver_id) {
      alert('⚠️ Thank You Notes can only be given against a closed business transaction where you were the Receiver.');
      return;
    }

    try {
      await axios.post('https://rmbbackend.rmbjaipur.com/auth/activities', {
        ...punchForm,
        type: apiType,
        giver_id: userId,
        source: 'Web Portal',
        request_source: 'Web Portal'
      });
      alert('Activity / Acknowledgement submitted successfully!');
      setShowPunchModal(false);
      fetchSessionAndData();
    } catch (err) {
      console.error('Error punching activity:', err);
      alert('Failed to submit activity.');
    }
  };

  const getStatusBadge = (st: string) => {
    switch (st) {
      case 'VERIFIED':
        return <span className="bg-emerald-100 text-emerald-800 border border-emerald-300 text-xs px-2.5 py-1 rounded-full font-bold flex items-center gap-1 w-max"><FaCheckCircle /> Verified</span>;
      case 'REJECTED':
        return <span className="bg-rose-100 text-rose-800 border border-rose-300 text-xs px-2.5 py-1 rounded-full font-bold flex items-center gap-1 w-max"><FaTimesCircle /> Rejected</span>;
      default:
        return <span className="bg-amber-100 text-amber-800 border border-amber-300 text-xs px-2.5 py-1 rounded-full font-bold flex items-center gap-1 w-max"><FaClock /> Pending Admin Verification</span>;
    }
  };

  // Filtered closed business transactions for Testimonial (Giver) and Thank You Note (Receiver)
  const closedBusinessGiveness = myActivities.filter(a => a.type === 'BUSINESS_ACK' && a.giver_id === userId);
  const closedBusinessReceives = myActivities.filter(a => a.type === 'BUSINESS_ACK' && a.receiver_id === userId);

  return (
    <div className={`min-h-screen font-sans transition-colors pb-20 lg:pb-0 ${
      theme === 'light' ? 'bg-[#F8FAFC] text-slate-900' : 'bg-[#131E32] text-slate-100'
    }`}>
      {/* 1. DESKTOP & MOBILE SIDEBAR NAVIGATION */}
      <aside className={`fixed inset-y-0 left-0 z-50 w-64 transform lg:transform-none transition-transform duration-300 flex flex-col border-r shadow-2xl ${
        mobileSidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
      } ${
        theme === 'light' ? 'bg-white border-slate-200 text-slate-900' : 'bg-[#0B1220] border-[#2A3B5C] text-white'
      }`}>
        {/* Brand Header */}
        <div className="p-3.5 border-b flex items-center justify-between border-inherit">
          <div
            onClick={() => {
              setActiveTab('Dashboard');
              setMobileSidebarOpen(false);
            }}
            className="flex items-center gap-2 cursor-pointer group flex-1 min-w-0"
          >
            <div className="bg-white px-2.5 py-1.5 rounded-xl shadow-md border border-slate-200 flex items-center justify-center group-hover:scale-[1.02] transition max-w-[185px] w-full">
              <img src={logo} alt="Rotary RMB Jaipur Logo" className="h-8 sm:h-9 w-auto object-contain max-w-full" />
            </div>
          </div>
          <button 
            onClick={() => setMobileSidebarOpen(false)} 
            className="lg:hidden p-1.5 rounded-lg text-slate-400 hover:text-white hover:bg-slate-800 flex-shrink-0 ml-1"
          >
            ✕
          </button>
        </div>

        {/* Vertical Navigation Menu Links */}
        <div className="flex-1 p-3 space-y-1.5 overflow-y-auto">
          {[
            { name: 'Dashboard', icon: FaAward },
            { name: 'Reports & Analytics', icon: FaChartBar },
            { name: 'Events & Calendar', icon: FaCalendarAlt },
            { name: 'My Profile & Credentials', icon: FaKey },
            { name: 'My Activity History', icon: FaHistory },
            { name: 'My Renewal Ledger', icon: FaCalendarCheck },
          ].map((t) => (
            <button
              key={t.name}
              onClick={() => {
                setActiveTab(t.name);
                setMobileSidebarOpen(false);
              }}
              className={`w-full px-3.5 py-3 rounded-xl transition flex items-center gap-3 font-bold text-xs cursor-pointer shadow-xs ${
                activeTab === t.name
                  ? (theme === 'light'
                      ? 'bg-[#0A2451] text-[#FDBC12] font-black shadow-md'
                      : 'bg-[#1E2B45] text-[#FDBC12] border border-[#FDBC12]/50 font-black shadow-md')
                  : (theme === 'light'
                      ? 'text-slate-700 hover:bg-slate-100 hover:text-slate-900'
                      : 'text-slate-300 hover:bg-[#1E2B45]/70 hover:text-white')
              }`}
            >
              <t.icon className={`text-base flex-shrink-0 ${activeTab === t.name ? 'text-[#FDBC12]' : 'text-slate-400'}`} />
              <span className="truncate">{t.name}</span>
            </button>
          ))}
        </div>

        {/* Sidebar Footer Quick Controls */}
        <div className="p-3 border-t space-y-2 border-inherit bg-slate-50/50 dark:bg-[#070D18]">
          {(userdetails?.role === 'admin' || userdetails?.role === 'superadmin' || localStorage.getItem('isImpersonating') === 'true') && (
            <button
              type="button"
              onClick={() => navigate('/dashboard')}
              className="w-full py-2 px-3 rounded-xl font-extrabold text-xs flex items-center justify-center gap-2 bg-[#0A2451] hover:bg-blue-900 text-amber-300 transition cursor-pointer shadow border border-amber-400/50"
            >
              🛡️ Act as Admin
            </button>
          )}

          <button
            type="button"
            onClick={toggleTheme}
            className={`w-full py-2 px-3 rounded-xl font-extrabold text-xs flex items-center justify-center gap-2 transition cursor-pointer border shadow-xs ${
              theme === 'light'
                ? 'bg-amber-100 text-amber-950 border-amber-300 hover:bg-amber-200'
                : 'bg-[#1E2B45] text-amber-300 border-amber-500/40 hover:bg-[#131E32]'
            }`}
          >
            {theme === 'light' ? '☀️ Light Theme' : '🌙 Dark Theme'}
          </button>

          {/* Logged in User Badge */}
          <div className="pt-2 border-t border-inherit flex items-center gap-3">
            <img
              className="h-9 w-9 rounded-full object-cover border-2 border-[#FDBC12] shadow flex-shrink-0"
              src={userdetails?.profile ? (userdetails.profile.startsWith('http') ? userdetails.profile : `https://rmbbackend.rmbjaipur.com/${userdetails.profile}`) : 'https://via.placeholder.com/150'}
              alt={userdetails?.name}
            />
            <div className="min-w-0 flex-1">
              <div className={`text-xs font-extrabold truncate ${theme === 'light' ? 'text-slate-900' : 'text-white'}`}>{userdetails?.name}</div>
              <div className="text-[10px] text-amber-500 font-semibold truncate">{userdetails?.sub_role || 'RMB Member'}</div>
            </div>
            <button 
              onClick={handleLogout}
              className="p-1.5 text-red-500 hover:text-red-700 hover:bg-red-500/10 rounded-lg transition cursor-pointer"
              title="Logout"
            >
              🚪
            </button>
          </div>
        </div>
      </aside>

      {/* Backdrop overlay for mobile sidebar */}
      {mobileSidebarOpen && (
        <div 
          onClick={() => setMobileSidebarOpen(false)} 
          className="fixed inset-0 bg-black/60 z-40 lg:hidden backdrop-blur-xs" 
        />
      )}

      {/* 2. MAIN RIGHT COLUMN & TOP HEADER */}
      <div className="flex-1 lg:pl-64 flex flex-col min-w-0">
        {/* IMPERSONATION ALERT BANNER */}
        {localStorage.getItem('isImpersonating') === 'true' && (
          <div className="bg-gradient-to-r from-purple-800 via-purple-700 to-indigo-800 text-white px-4 sm:px-6 py-2.5 flex flex-wrap justify-between items-center shadow-lg border-b border-purple-400/40 sticky top-0 z-40">
            <div className="flex items-center gap-2 font-black text-xs sm:text-sm">
              <span className="text-xl animate-pulse">🎭</span>
              <span>ADMIN IMPERSONATION MODE ACTIVE: Logged in as <strong className="text-amber-300 font-black text-sm">{userdetails?.name || 'Member'}</strong> ({userdetails?.company_name || 'RMB Chapter Member'})</span>
            </div>
            <button
              onClick={async () => {
                try {
                  await axios.post('https://rmbbackend.rmbjaipur.com/auth/exit-impersonation', {}, { withCredentials: true });
                  localStorage.removeItem('isImpersonating');
                  localStorage.removeItem('impersonatedUser');
                  navigate('/dashboard');
                } catch (err) {
                  console.error('Error exiting impersonation:', err);
                  localStorage.removeItem('isImpersonating');
                  navigate('/dashboard');
                }
              }}
              className="px-4 py-1.5 bg-amber-400 hover:bg-amber-300 text-[#0A2451] font-black text-xs rounded-xl shadow cursor-pointer transition flex items-center gap-1.5 border border-amber-300"
            >
              ↩️ Exit Impersonation & Return to Admin Panel
            </button>
          </div>
        )}

        <header className={`h-16 border-b px-4 sm:px-6 flex items-center justify-between sticky top-0 z-30 transition-colors ${
          theme === 'light' ? 'bg-white border-slate-200 text-slate-900' : 'bg-[#0B1220] border-[#2A3B5C] text-white'
        }`}>
          <div className="flex items-center gap-3">
            <button 
              onClick={() => setMobileSidebarOpen(true)}
              className="lg:hidden p-2 rounded-xl bg-slate-100 dark:bg-[#1E2B45] text-slate-700 dark:text-white"
            >
              ☰
            </button>
            <h1 className="text-sm sm:text-base font-extrabold tracking-wide flex items-center gap-2">
              <span className="px-2.5 py-1 rounded-lg bg-amber-500/20 text-[#FDBC12] text-xs font-black">📌 {activeTab}</span>
            </h1>
          </div>

          <div className="flex items-center gap-1.5 sm:gap-3">
            {(userdetails?.role === 'admin' || userdetails?.role === 'superadmin' || localStorage.getItem('isImpersonating') === 'true') && (
              <button
                type="button"
                onClick={() => navigate('/dashboard')}
                className="px-2.5 py-1.5 rounded-xl font-extrabold text-[11px] sm:text-xs flex items-center gap-1 bg-[#0A2451] hover:bg-blue-900 text-amber-300 transition cursor-pointer shadow-md border border-amber-400/50"
                title="Back to Admin Portal"
              >
                <span>🛡️</span> <span className="hidden sm:inline">Act as Admin</span><span className="sm:hidden">Admin</span>
              </button>
            )}

            <button
              type="button"
              onClick={toggleTheme}
              className={`p-2 sm:px-3 sm:py-1.5 rounded-xl font-extrabold text-xs flex items-center gap-1 transition cursor-pointer border shadow-xs ${
                theme === 'light'
                  ? 'bg-amber-100 text-amber-950 border-amber-300 hover:bg-amber-200'
                  : 'bg-[#1E2B45] text-amber-300 border-amber-500/40 hover:bg-[#131E32]'
              }`}
              title="Toggle Light / Dark Mode"
            >
              {theme === 'light' ? '☀️' : '🌙'}
              <span className="hidden sm:inline">{theme === 'light' ? ' Light' : ' Dark'}</span>
            </button>

            <button
              type="button"
              onClick={handleLogout}
              className="px-2.5 py-1.5 rounded-xl font-extrabold text-[11px] sm:text-xs flex items-center gap-1 bg-rose-600 hover:bg-rose-700 text-white transition cursor-pointer shadow-md border border-rose-500/50"
              title="Sign Out / Logout"
            >
              <span>🚪</span> <span className="hidden sm:inline">Sign Out</span><span className="sm:hidden">Exit</span>
            </button>

            {/* Notification Bell Button & Center Drawer */}
            <div className="relative">
              <button
                type="button"
                onClick={() => {
                  setShowNotifDrawer(prev => !prev);
                  if (unreadCount > 0) handleMarkNotificationsRead();
                }}
                className="relative p-2.5 rounded-xl bg-slate-100 dark:bg-[#1E2B45] text-slate-700 dark:text-amber-300 hover:bg-slate-200 dark:hover:bg-[#131E32] transition cursor-pointer border border-slate-200 dark:border-[#2A3B5C]"
                title="Member Notifications & Announcements"
              >
                <FaBell className="text-base" />
                {unreadCount > 0 && (
                  <span className="absolute -top-1 -right-1 px-1.5 py-0.5 bg-red-600 text-white font-black text-[9px] rounded-full animate-pulse shadow-md">
                    {unreadCount}
                  </span>
                )}
              </button>

              {/* Notification Drawer Dropdown */}
              {showNotifDrawer && (
                <div className="absolute right-0 mt-3 w-80 sm:w-96 bg-white dark:bg-[#1E2B45] border border-slate-200 dark:border-[#2A3B5C] rounded-2xl shadow-2xl z-50 overflow-hidden animate-scale-in text-slate-900 dark:text-slate-100">
                  <div className="p-4 bg-slate-50 dark:bg-[#131E32] border-b border-slate-200 dark:border-[#2A3B5C] flex items-center justify-between">
                    <h3 className="text-xs font-black uppercase tracking-wider flex items-center gap-2 text-slate-800 dark:text-white">
                      <FaBell className="text-[#FDBC12]" /> Member Notifications ({notifications.length})
                    </h3>
                    <div className="flex items-center gap-2">
                      {notifications.length > 0 && (
                        <button
                          type="button"
                          onClick={handleClearNotifications}
                          className="text-[10px] text-slate-400 hover:text-red-400 font-bold transition cursor-pointer"
                        >
                          Clear All
                        </button>
                      )}
                      <button
                        type="button"
                        onClick={() => setShowNotifDrawer(false)}
                        className="text-slate-400 hover:text-slate-600 dark:hover:text-white text-xs font-bold p-1 cursor-pointer"
                      >
                        ✕
                      </button>
                    </div>
                  </div>

                  <div className="max-h-80 overflow-y-auto divide-y divide-slate-100 dark:divide-[#2A3B5C]">
                    {notifications.length > 0 ? (
                      notifications.map((n: any) => (
                        <div key={n.id} className="p-3.5 hover:bg-slate-50 dark:hover:bg-[#131E32]/50 transition text-left space-y-1">
                          <div className="flex items-center justify-between gap-2">
                            <span className="font-black text-xs text-amber-500 flex items-center gap-1.5">
                              {n.type === 'SOCIETY_YEAR' ? '🏆 SOCIETY YEAR' : n.type === 'POINTS' ? '⚡ POINTS RESET' : '📢 ANNOUNCEMENT'}
                            </span>
                            <span className="text-[10px] text-slate-400 font-mono">
                              {n.created_at ? new Date(n.created_at).toLocaleDateString() : 'Just now'}
                            </span>
                          </div>
                          <h4 className="font-bold text-xs text-slate-900 dark:text-white leading-snug">{n.title}</h4>
                          <p className="text-[11px] text-slate-600 dark:text-slate-300 leading-relaxed">{n.message}</p>
                        </div>
                      ))
                    ) : (
                      <div className="p-8 text-center text-xs text-slate-400 space-y-1">
                        <span className="text-2xl block">🔕</span>
                        <p>No new notifications at this time.</p>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            <div className="flex items-center gap-2.5 pl-2 border-l border-slate-200 dark:border-slate-800">
              <img
                className="h-8 w-8 rounded-full object-cover border-2 border-[#FDBC12] shadow"
                src={userdetails?.profile ? (userdetails.profile.startsWith('http') ? userdetails.profile : `https://rmbbackend.rmbjaipur.com/${userdetails.profile}`) : 'https://via.placeholder.com/150'}
                alt={userdetails?.name}
              />
              <div className="text-left hidden sm:block">
                <div className={`text-xs font-bold leading-tight ${theme === 'light' ? 'text-slate-900' : 'text-white'}`}>{userdetails?.name}</div>
                <div className="text-[10px] text-amber-500 font-semibold">{userdetails?.sub_role || 'Member'}</div>
              </div>
            </div>
          </div>
        </header>

        {/* Main Content Container */}
        <main className="p-3 py-4 sm:p-6 max-w-7xl w-full mx-auto pb-24 lg:pb-6">

        {/* MOBILE WEB APP QUICK PUNCH CAROUSEL BAR */}
        <div className="lg:hidden mb-4 overflow-x-auto no-scrollbar py-1">
          <div className="flex items-center gap-2.5 min-w-max">
            <button
              onClick={() => openPunchModal('R2R')}
              className="px-3.5 py-2 rounded-xl bg-gradient-to-r from-indigo-950 via-[#0D3880] to-indigo-900 text-amber-300 font-black text-xs border border-indigo-400/40 shadow-md flex items-center gap-1.5 active:scale-95 transition cursor-pointer"
            >
              <span>🤝</span> + Punch R2R
            </button>

            <button
              onClick={() => openPunchModal('BUSINESS')}
              className="px-3.5 py-2 rounded-xl bg-gradient-to-r from-emerald-950 to-emerald-800 text-emerald-200 font-black text-xs border border-emerald-400/40 shadow-md flex items-center gap-1.5 active:scale-95 transition cursor-pointer"
            >
              <span>💰</span> + Given/Recv
            </button>

            <button
              onClick={() => openPunchModal('REFERRAL')}
              className="px-3.5 py-2 rounded-xl bg-gradient-to-r from-purple-950 to-purple-800 text-purple-200 font-black text-xs border border-purple-400/40 shadow-md flex items-center gap-1.5 active:scale-95 transition cursor-pointer"
            >
              <span>📢</span> + Referral
            </button>

            <button
              onClick={() => openPunchModal('VISITOR')}
              className="px-3.5 py-2 rounded-xl bg-gradient-to-r from-blue-950 to-blue-800 text-blue-200 font-black text-xs border border-blue-400/40 shadow-md flex items-center gap-1.5 active:scale-95 transition cursor-pointer"
            >
              <span>👤</span> + Visitor
            </button>

            <button
              onClick={() => openPunchModal('ATTENDANCE')}
              className="px-3.5 py-2 rounded-xl bg-gradient-to-r from-amber-950 to-amber-800 text-amber-200 font-black text-xs border border-amber-400/40 shadow-md flex items-center gap-1.5 active:scale-95 transition cursor-pointer"
            >
              <span>📅</span> Attendance
            </button>
          </div>
        </div>

        {/* TEXT NEWS TICKER BANNER (Scrolling Marquee) */}
        {textNewsHeading && (
          <div className="mb-4 sm:mb-6 bg-gradient-to-r from-[#131E32] via-[#0A2451] to-[#131E32] border-2 border-[#FDBC12] rounded-2xl p-3 sm:p-4 shadow-xl flex items-center gap-3">
            <div className="bg-[#FDBC12] text-[#0A2451] font-black text-xs uppercase px-2.5 sm:px-3 py-1 sm:py-1.5 rounded-xl shadow-md flex items-center gap-1.5 flex-shrink-0 z-10">
              <span>📢</span>
              <span className="hidden sm:inline">TEXT NEWS</span>
            </div>
            <div className="overflow-hidden w-full relative whitespace-nowrap">
              <div 
                className="inline-block text-xs sm:text-sm md:text-base font-bold text-amber-300 tracking-wide cursor-pointer hover:[animation-play-state:paused]"
                style={{
                  display: 'inline-block',
                  whiteSpace: 'nowrap',
                  animation: 'marqueeScroll 25s linear infinite'
                }}
              >
                <span>{textNewsHeading}</span>
              </div>
              <style>{`
                @keyframes marqueeScroll {
                  0% { transform: translateX(100%); }
                  100% { transform: translateX(-100%); }
                }
              `}</style>
            </div>
          </div>
        )}

        {/* TAB 1: DASHBOARD */}
        {activeTab === 'Dashboard' && (
          <div className="space-y-6">
            
            {/* Birthday Check */}
            {userdetails?.DOB && new Date(userdetails.DOB).getMonth() === new Date().getMonth() && new Date(userdetails.DOB).getDate() === new Date().getDate() && (
              <div className="bg-gradient-to-r from-pink-500 to-rose-500 p-5 rounded-xl shadow-lg text-white flex flex-col items-center">
                <h3 className="text-2xl font-black mb-2">🎉 Happy Birthday, {userdetails.name}! 🎂</h3>
                <BirthdayPoster name={userdetails.name} profileUrl={`https://rmbbackend.rmbjaipur.com/${userdetails.profile}`} />
              </div>
            )}

            {/* Main Grid: Left 6 Cards + Right Profile Summary */}
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">

              {/* LEFT SECTION: 6 Cards Grid (Responsive 2 cols on mobile, 3 cols on tablet/desktop as per screenshot) */}
              <div className="lg:col-span-3 grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-5">

                {/* Card 1: Total Presence */}
                <div className="bg-white dark:bg-[#1E2B45] border border-slate-200 dark:border-[#2A3B5C] hover:border-[#FDBC12] rounded-2xl p-4 shadow-sm flex flex-col justify-between items-center text-center transition">
                  <div className="h-12 w-12 rounded-full bg-[#0A2451] text-amber-400 flex items-center justify-center text-xl shadow-md mb-2">
                    <FaUsers />
                  </div>
                  <div className="text-2xl font-black text-amber-500 my-0.5">{metrics.presence}</div>
                  <h3 className="text-xs font-black text-slate-900 dark:text-white mb-0.5">Total Presence</h3>
                  <p className="text-[10px] text-slate-500 dark:text-slate-400 leading-tight">Records showing presence for the user.</p>
                </div>

                {/* Card 2: Business Data Give */}
                <div className="bg-white dark:bg-[#1E2B45] border border-slate-200 dark:border-[#2A3B5C] hover:border-[#FDBC12] rounded-2xl p-4 shadow-sm flex flex-col justify-between items-center text-center transition">
                  <div className="h-12 w-12 rounded-full bg-[#0A2451] text-amber-400 flex items-center justify-center text-xl shadow-md mb-2">
                    <FaGift />
                  </div>
                  <div className="text-2xl font-black text-amber-500 my-0.5">
                    {metrics.businessGive > 0 ? `₹${(metrics.businessGive / 1000).toFixed(0)}k` : '0'}
                  </div>
                  <h3 className="text-xs font-black text-slate-900 dark:text-white mb-0.5">Business Data Give</h3>
                  <p className="text-[10px] text-slate-500 dark:text-slate-400 leading-tight">
                    {metrics.businessGiveCount > 0 ? `${metrics.businessGiveCount} Given (₹${metrics.businessGive.toLocaleString()})` : 'No records found.'}
                  </p>
                </div>

                {/* Card 3: Business Data Receiver */}
                <div className="bg-white dark:bg-[#1E2B45] border border-slate-200 dark:border-[#2A3B5C] hover:border-[#FDBC12] rounded-2xl p-4 shadow-sm flex flex-col justify-between items-center text-center transition">
                  <div className="h-12 w-12 rounded-full bg-[#0A2451] text-amber-400 flex items-center justify-center text-xl shadow-md mb-2">
                    <FaBriefcase />
                  </div>
                  <div className="text-2xl font-black text-amber-500 my-0.5">
                    {metrics.businessReceive > 0 ? `₹${(metrics.businessReceive / 1000).toFixed(0)}k` : '0'}
                  </div>
                  <h3 className="text-xs font-black text-slate-900 dark:text-white mb-0.5">Business Data Receiver</h3>
                  <p className="text-[10px] text-slate-500 dark:text-slate-400 leading-tight">
                    {metrics.businessReceiveCount > 0 ? `${metrics.businessReceiveCount} Received (₹${metrics.businessReceive.toLocaleString()})` : 'No records found.'}
                  </p>
                </div>

                {/* Card 4: Total R2R Done */}
                <div className="bg-white dark:bg-[#1E2B45] border border-slate-200 dark:border-[#2A3B5C] hover:border-[#FDBC12] rounded-2xl p-4 shadow-sm flex flex-col justify-between items-center text-center transition">
                  <div className="h-12 w-12 rounded-full bg-[#0A2451] text-amber-400 flex items-center justify-center text-xl shadow-md mb-2">
                    <FaHandshake />
                  </div>
                  <div className="text-2xl font-black text-amber-500 my-0.5">{metrics.r2rCount}</div>
                  <h3 className="text-xs font-black text-slate-900 dark:text-white mb-0.5">Total R2R Done</h3>
                  <p className="text-[10px] text-slate-500 dark:text-slate-400 leading-tight">1-to-1 business meetings completed.</p>
                </div>

                {/* Card 5: Reference Data */}
                <div className="bg-white dark:bg-[#1E2B45] border border-slate-200 dark:border-[#2A3B5C] hover:border-[#FDBC12] rounded-2xl p-4 shadow-sm flex flex-col justify-between items-center text-center transition">
                  <div className="h-12 w-12 rounded-full bg-[#0A2451] text-amber-400 flex items-center justify-center text-xl shadow-md mb-2">
                    <FaFileAlt />
                  </div>
                  <div className="text-2xl font-black text-amber-500 my-0.5">{metrics.referralCount}</div>
                  <h3 className="text-xs font-black text-slate-900 dark:text-white mb-0.5">Reference Data</h3>
                  <p className="text-[10px] text-slate-500 dark:text-slate-400 leading-tight">Business lead referrals passed.</p>
                </div>

                {/* Card 6: Visitor Data */}
                <div className="bg-white dark:bg-[#1E2B45] border border-slate-200 dark:border-[#2A3B5C] hover:border-[#FDBC12] rounded-2xl p-4 shadow-sm flex flex-col justify-between items-center text-center transition">
                  <div className="h-12 w-12 rounded-full bg-[#0A2451] text-amber-400 flex items-center justify-center text-xl shadow-md mb-2">
                    <FaUser />
                  </div>
                  <div className="text-2xl font-black text-amber-500 my-0.5">{metrics.visitorCount}</div>
                  <h3 className="text-xs font-black text-slate-900 dark:text-white mb-0.5">Visitor Data</h3>
                  <p className="text-[10px] text-slate-500 dark:text-slate-400 leading-tight">Meeting guests invited.</p>
                </div>

              </div>

              {/* RIGHT SECTION: User Profile Card, QUICK ACTIONS, & APPRECIATION */}
              <div className="space-y-4">
                {/* Profile Card Container (Deep Navy #0A2451 as per screenshot) */}
                <div className="bg-[#0A2451] border border-[#2A3B5C] rounded-2xl p-5 shadow-xl text-center space-y-3 relative overflow-hidden text-white">
                  {/* Decorative Background Glow */}
                  <div className="absolute -top-10 -right-10 w-32 h-32 bg-[#FDBC12]/10 rounded-full blur-2xl pointer-events-none" />

                  {/* Centered Avatar Image & Points Badge */}
                  <div className="flex flex-col items-center justify-center space-y-2">
                    <div className="relative inline-block">
                      <img
                        src={userdetails?.profile ? (userdetails.profile.startsWith('http') ? userdetails.profile : `https://rmbbackend.rmbjaipur.com/${userdetails.profile}`) : 'https://via.placeholder.com/150'}
                        alt={userdetails?.name}
                        className="w-20 h-20 rounded-full object-cover border-4 border-[#FDBC12] shadow-xl mx-auto ring-4 ring-amber-500/20"
                      />
                    </div>

                    {/* Points Scorecard Pill */}
                    <div className="inline-flex items-center justify-center gap-1.5 bg-[#071530] text-amber-300 font-black text-xs px-4 py-1.5 rounded-full shadow-lg border border-amber-400/40">
                      <span>🏆</span>
                      <span>{userdetails?.point || 0} Total Points</span>
                    </div>
                  </div>

                  {/* Member Name & Subtitle */}
                  <div className="space-y-0.5">
                    <h2 className="text-lg font-extrabold text-white tracking-wide">{userdetails?.name || 'Ashish Bhardwaj'}</h2>
                    <div className="inline-block px-3 py-0.5 rounded-full text-[11px] font-bold bg-[#131E32] text-amber-300 border border-[#2A3B5C]">
                      🏛️ {userdetails?.company_name || 'RMB Chapter Member'}
                    </div>
                  </div>

                  {/* RBAC Role & Responsibilities Badge Card */}
                  {(() => {
                    let permList: string[] = [];
                    if (userdetails?.permissions) {
                      if (Array.isArray(userdetails.permissions)) permList = userdetails.permissions;
                      else if (typeof userdetails.permissions === 'string') {
                        try {
                          const parsed = JSON.parse(userdetails.permissions);
                          if (Array.isArray(parsed)) permList = parsed;
                        } catch {
                          permList = userdetails.permissions.split(',').map((p: string) => p.trim()).filter(Boolean);
                        }
                      }
                    }

                    const subRoleName = userdetails?.sub_role || (userdetails?.role && userdetails.role !== 'member' ? userdetails.role : '');

                    const PERM_TITLES: Record<string, { title: string; icon: string }> = {
                      'manage_members': { title: 'Member Roster Admin', icon: '👥' },
                      'manage_audit_ledger': { title: 'Audit Ledger Admin', icon: '💰' },
                      'verify_activities': { title: 'Activity Verifier', icon: '📋' },
                      'manage_dynamic_forms': { title: 'Forms & Visitor Admin', icon: '📝' },
                      'manage_events': { title: 'Events & Meetings Manager', icon: '🗓️' },
                      'manage_ai_flyer': { title: 'AI Poster Studio', icon: '🤖' },
                      'manage_gallery': { title: 'Gallery & Media Admin', icon: '🖼️' },
                      'manage_points': { title: 'Point Master Admin', icon: '🏆' },
                      'view_reports': { title: 'Analytics & Reports', icon: '📊' },
                      'manage_rbac': { title: 'RBAC Control Admin', icon: '🛡️' }
                    };

                    return (
                      <div className="bg-[#131E32] border border-amber-400/30 rounded-2xl p-3.5 space-y-2 text-left shadow-lg">
                        <div className="flex items-center justify-between border-b border-[#2A3B5C] pb-2">
                          <span className="text-[10px] font-black uppercase text-amber-400 tracking-wider flex items-center gap-1.5">
                            <span>🛡️</span> RBAC Role & Responsibilities
                          </span>
                          {subRoleName && (
                            <span className="bg-[#FDBC12] text-[#0A2451] font-black text-[10px] px-2.5 py-0.5 rounded-full shadow-xs">
                              {subRoleName}
                            </span>
                          )}
                        </div>

                        {permList.length > 0 ? (
                          <div className="flex flex-wrap gap-1.5 pt-1">
                            {permList.map((key: string) => {
                              const info = PERM_TITLES[key] || { title: key.replace(/_/g, ' '), icon: '⭐' };
                              return (
                                <span key={key} className="bg-indigo-950/80 text-amber-300 border border-indigo-400/30 text-[10px] font-bold px-2 py-0.5 rounded-lg flex items-center gap-1">
                                  <span>{info.icon}</span> {info.title}
                                </span>
                              );
                            })}
                          </div>
                        ) : (
                          <p className="text-[10px] text-slate-400 font-medium">Standard member access assigned.</p>
                        )}
                      </div>
                    );
                  })()}

                  {/* Structured Details List */}
                  <div className="border-t border-[#2A3B5C] pt-3 space-y-1.5 text-xs font-semibold text-slate-300">
                    <div className="bg-[#131E32]/80 border border-[#2A3B5C] px-3.5 py-2 rounded-xl flex items-center justify-between shadow-xs">
                      <span className="text-slate-400 font-bold flex items-center gap-1.5">
                        <span>🌐</span> Website
                      </span>
                      {userdetails?.company_website ? (
                        <a
                          href={userdetails.company_website.startsWith('http') ? userdetails.company_website : `https://${userdetails.company_website}`}
                          target="_blank"
                          rel="noreferrer"
                          className="font-extrabold text-cyan-300 hover:underline truncate max-w-[150px]"
                        >
                          {userdetails.company_website.replace(/^https?:\/\//, '')}
                        </a>
                      ) : (
                        <span className="font-extrabold text-slate-400 font-mono text-[11px]">rmbjaipur.com</span>
                      )}
                    </div>

                    <div className="bg-[#131E32]/80 border border-[#2A3B5C] px-3.5 py-2 rounded-xl flex items-center justify-between shadow-xs">
                      <span className="text-slate-400 font-bold flex items-center gap-1.5">
                        <span>📅</span> Joined On
                      </span>
                      <span className="font-extrabold text-white">{formatDateDisplay(userdetails?.Time)}</span>
                    </div>

                    <div className="bg-[#131E32]/80 border border-[#2A3B5C] px-3.5 py-2 rounded-xl flex items-center justify-between shadow-xs">
                      <span className="text-slate-400 font-bold flex items-center gap-1.5">
                        <span>⏳</span> Membership Valid Until
                      </span>
                      <span className="font-extrabold text-amber-400">{formatDateDisplay(userdetails?.expire)}</span>
                    </div>

                    <div className="bg-[#131E32]/80 border border-[#2A3B5C] px-3.5 py-2 rounded-xl flex items-center justify-between shadow-xs">
                      <span className="text-slate-400 font-bold flex items-center gap-1.5">
                        <span>📍</span> Chapter / City
                      </span>
                      <span className="font-extrabold text-blue-300">Jaipur</span>
                    </div>

                    <div className="bg-[#131E32]/80 border border-amber-400/30 px-3.5 py-2 rounded-xl flex items-center justify-between shadow-xs">
                      <span className="text-amber-400 font-bold flex items-center gap-1.5">
                        <span>🔑</span> Account Password
                      </span>
                      <div className="flex items-center gap-2 font-mono font-extrabold text-amber-300 text-xs">
                        <span>{showProfilePassword ? (userdetails?.plain_password || userdetails?.password || '••••••••') : '••••••••'}</span>
                        <button
                          type="button"
                          onClick={() => setShowProfilePassword(!showProfilePassword)}
                          className="text-slate-400 hover:text-white text-[11px] font-sans font-bold cursor-pointer bg-[#0A2451] px-2 py-0.5 rounded border border-slate-600"
                        >
                          {showProfilePassword ? '🙈 Hide' : '👁️ Show'}
                        </button>
                        <button
                          type="button"
                          onClick={() => setShowResetPasswordModal(true)}
                          className="text-[#FDBC12] hover:text-amber-300 text-[11px] font-sans font-black cursor-pointer bg-amber-500/20 px-2 py-0.5 rounded border border-amber-400/40"
                          title="Reset / Change Password"
                        >
                          ✏️ Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* QUICK ACTIONS Section */}
                <div>
                  <h4 className="text-xs font-black text-slate-700 dark:text-slate-300 uppercase tracking-wider mb-2">QUICK ACTIONS</h4>
                  <div className="grid grid-cols-4 gap-2">
                    <button
                      onClick={() => openPunchModal('R2R')}
                      className="bg-[#0A2451] hover:bg-blue-900 text-white p-2.5 rounded-xl border border-blue-400/30 flex flex-col items-center justify-center gap-1 transition shadow cursor-pointer active:scale-95"
                    >
                      <FaHandshake className="text-[#FDBC12] text-base" />
                      <span className="text-[11px] font-extrabold">+ R2R</span>
                    </button>

                    <button
                      onClick={() => openPunchModal('BUSINESS')}
                      className="bg-[#0A2451] hover:bg-blue-900 text-white p-2.5 rounded-xl border border-blue-400/30 flex flex-col items-center justify-center gap-1 transition shadow cursor-pointer active:scale-95"
                    >
                      <FaBriefcase className="text-[#FDBC12] text-base" />
                      <span className="text-[11px] font-extrabold">+ Business</span>
                    </button>

                    <button
                      onClick={() => openPunchModal('REFERRAL')}
                      className="bg-[#0A2451] hover:bg-blue-900 text-white p-2.5 rounded-xl border border-blue-400/30 flex flex-col items-center justify-center gap-1 transition shadow cursor-pointer active:scale-95"
                    >
                      <FaFileAlt className="text-[#FDBC12] text-base" />
                      <span className="text-[11px] font-extrabold">+ Referral</span>
                    </button>

                    <button
                      onClick={() => openPunchModal('VISITOR')}
                      className="bg-[#0A2451] hover:bg-blue-900 text-white p-2.5 rounded-xl border border-blue-400/30 flex flex-col items-center justify-center gap-1 transition shadow cursor-pointer active:scale-95"
                    >
                      <FaUserPlus className="text-[#FDBC12] text-base" />
                      <span className="text-[11px] font-extrabold">+ Visitor</span>
                    </button>
                  </div>
                </div>

                {/* APPRECIATION Section */}
                <div>
                  <h4 className="text-xs font-black text-slate-700 dark:text-slate-300 uppercase tracking-wider mb-2">APPRECIATION</h4>
                  <div className="grid grid-cols-3 gap-2 text-xs">
                    <button
                      onClick={() => openPunchModal('ATTENDANCE')}
                      className="bg-[#0A2451] hover:bg-blue-900 text-white border border-blue-400/30 py-2.5 px-1.5 rounded-xl font-extrabold flex items-center justify-center gap-1.5 transition shadow cursor-pointer active:scale-95"
                    >
                      <FaCalendarAlt className="text-[#FDBC12] text-sm" /> Attendance
                    </button>
                    <button
                      onClick={() => openPunchModal('TESTIMONIAL')}
                      className="bg-[#0A2451] hover:bg-blue-900 text-white border border-blue-400/30 py-2.5 px-1.5 rounded-xl font-extrabold flex items-center justify-center gap-1.5 transition shadow cursor-pointer active:scale-95"
                    >
                      <FaStar className="text-amber-400 text-sm" /> Testimonial
                    </button>
                    <button
                      onClick={() => openPunchModal('THANK_YOU')}
                      className="bg-[#0A2451] hover:bg-blue-900 text-white border border-blue-400/30 py-2.5 px-1.5 rounded-xl font-extrabold flex items-center justify-center gap-1.5 transition shadow cursor-pointer active:scale-95"
                    >
                      <FaHeart className="text-rose-400 text-sm" /> Thank You
                    </button>
                  </div>
                </div>

              </div>

            </div>

            {/* BOTTOM SECTION: Next Meeting / Event Notification Banner */}
            <div className="bg-[#1E2B45] border border-[#2A3B5C] p-4 rounded-xl shadow-lg">
              <h4 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1">Next Meeting / Event</h4>
              <p className="text-sm font-extrabold text-[#FDBC12]">{nextEventTitle}</p>
            </div>

          </div>
        )}

        {/* TAB: REPORTS & ANALYTICS */}
        {activeTab === 'Reports & Analytics' && (
          <div className="space-y-4">
            <ReportsAnalytics isMemberPortal={true} />
          </div>
        )}

        {/* TAB 2: EVENTS & CALENDAR */}
        {activeTab === 'Events & Calendar' && (
          <div className="bg-white p-4 rounded-xl text-gray-900 shadow-xl border">
            <EventsCalendar isMemberPortal={true} />
          </div>
        )}

        {/* TAB 3: MY PROFILE & CREDENTIALS */}
        {activeTab === 'My Profile & Credentials' && (
          <form onSubmit={handleProfileSave} className="space-y-6 text-slate-100">
            <div className="bg-[#1E2B45] p-5 rounded-xl border border-[#2A3B5C] flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
              <div>
                <h2 className="text-lg font-bold text-white">My Profile & Account Settings</h2>
                <p className="text-xs text-slate-400">Update your profile picture, company details, credentials, and date of birth.</p>
              </div>
              <button
                type="submit"
                className="flex items-center gap-2 px-5 py-2.5 bg-[#FDBC12] hover:bg-amber-400 text-[#0A2451] font-black text-xs rounded-lg shadow cursor-pointer"
              >
                <FaSave /> Save Profile Changes
              </button>
            </div>

            {/* Profile Picture Upload Header Card */}
            <div className="bg-[#1E2B45] p-5 rounded-xl border border-[#2A3B5C] flex flex-col sm:flex-row items-center gap-6">
              <div className="relative flex-shrink-0">
                <img
                  src={
                    profileForm.profile
                      ? (profileForm.profile.startsWith('http') ? profileForm.profile : `https://rmbbackend.rmbjaipur.com/${profileForm.profile.replace(/\\/g, '/')}`)
                      : (userdetails?.profile ? `https://rmbbackend.rmbjaipur.com/${userdetails.profile.replace(/\\/g, '/')}` : 'https://via.placeholder.com/150')
                  }
                  alt={profileForm.name || 'Member Photo'}
                  className="w-28 h-28 rounded-full object-cover border-4 border-[#FDBC12] shadow-xl"
                  onError={(e) => { e.currentTarget.src = 'https://via.placeholder.com/150'; }}
                />
              </div>

              <div className="flex-1 space-y-2 text-center sm:text-left">
                <h3 className="font-bold text-white text-base">Profile Photo</h3>
                <p className="text-xs text-slate-400">Upload a professional headshot to display across the member portal and roster.</p>
                <div className="flex flex-wrap items-center justify-center sm:justify-start gap-3 pt-1">
                  <label className="cursor-pointer bg-[#0D3880] hover:bg-[#16469C] text-white px-4 py-2 rounded-lg text-xs font-bold flex items-center gap-2 border border-blue-400/30 transition shadow">
                    <FaUpload /> Select New Photo
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleProfilePhotoChange}
                      className="hidden"
                    />
                  </label>
                  {profileUploading && <span className="text-xs text-[#FDBC12] font-bold animate-pulse">Uploading photo...</span>}
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Credentials & Security */}
              <div className="bg-[#1E2B45] p-5 rounded-xl border border-[#2A3B5C] space-y-4 text-xs">
                <h3 className="font-bold text-[#FDBC12] border-b border-[#2A3B5C] pb-2 flex items-center gap-2">
                  <FaKey /> Security & Credentials
                </h3>

                <div>
                  <label className="font-bold text-slate-300 block mb-1">User ID / Email Address *</label>
                  <input
                    type="email"
                    value={profileForm.email || ''}
                    onChange={(e) => setProfileForm({ ...profileForm, email: e.target.value })}
                    className="w-full p-2.5 bg-[#131E32] border border-[#2A3B5C] rounded-lg outline-none font-bold text-white focus:border-[#FDBC12]"
                    required
                  />
                </div>

                <div>
                  <label className="font-bold text-slate-300 block mb-1">Change Password</label>
                  <div className="relative">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      value={profileForm.password || ''}
                      onChange={(e) => setProfileForm({ ...profileForm, password: e.target.value })}
                      className="w-full p-2.5 pr-10 bg-[#131E32] border border-[#2A3B5C] rounded-lg outline-none font-mono font-bold text-[#FDBC12] focus:border-[#FDBC12]"
                      placeholder="Enter new password"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-3 top-2.5 text-slate-400 hover:text-white"
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                </div>

                <div>
                  <label className="font-bold text-slate-300 block mb-1">Mobile Phone Number</label>
                  <input
                    type="text"
                    value={profileForm.number || ''}
                    onChange={(e) => setProfileForm({ ...profileForm, number: e.target.value })}
                    className="w-full p-2.5 bg-[#131E32] border border-[#2A3B5C] rounded-lg outline-none text-white focus:border-[#FDBC12]"
                    placeholder="+91 98290XXXXX"
                  />
                </div>
              </div>

              {/* Classification & Lifecycle Dates */}
              <div className="bg-[#1E2B45] p-5 rounded-xl border border-[#2A3B5C] space-y-4 text-xs">
                <h3 className="font-bold text-emerald-400 border-b border-[#2A3B5C] pb-2 flex items-center gap-2">
                  <FaCalendarAlt /> Classification & Dates
                </h3>

                {/* Read-only Classification */}
                <div>
                  <label className="font-bold text-slate-300 block mb-1 flex items-center justify-between">
                    <span>Classification / Role</span>
                    <span className="text-[10px] text-amber-400 font-bold flex items-center gap-1">
                      <FaLock size={10} /> Set by Admin (Read Only)
                    </span>
                  </label>
                  <input
                    type="text"
                    value={`${profileForm.designation || 'RMB Member'} ${profileForm.sub_role ? `(${profileForm.sub_role})` : ''}`}
                    readOnly
                    disabled
                    className="w-full p-2.5 bg-[#0B1220] border border-[#2A3B5C] rounded-lg outline-none font-bold text-slate-400 cursor-not-allowed"
                  />
                </div>

                <div>
                  <label className="font-bold text-slate-300 block mb-1">🎂 Date of Birth (DOB)</label>
                  <input
                    type="date"
                    value={profileForm.DOB || ''}
                    onChange={(e) => setProfileForm({ ...profileForm, DOB: e.target.value })}
                    className="w-full p-2.5 bg-[#131E32] border border-[#2A3B5C] rounded-lg outline-none font-bold text-white focus:border-[#FDBC12]"
                  />
                </div>

                <div className="grid grid-cols-2 gap-3 pt-1">
                  <div>
                    <label className="font-bold text-slate-400 block mb-1">Date of Joining</label>
                    <input
                      type="date"
                      value={profileForm.Time || ''}
                      readOnly
                      disabled
                      className="w-full p-2 bg-[#0B1220] border border-[#2A3B5C] rounded-lg outline-none text-slate-400 cursor-not-allowed"
                    />
                  </div>
                  <div>
                    <label className="font-bold text-slate-400 block mb-1">Membership Expiry</label>
                    <input
                      type="date"
                      value={profileForm.expire || ''}
                      readOnly
                      disabled
                      className="w-full p-2 bg-[#0B1220] border border-[#2A3B5C] rounded-lg outline-none text-amber-400 cursor-not-allowed"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Company & Business Profile Details */}
            <div className="bg-[#1E2B45] p-5 rounded-xl border border-[#2A3B5C] text-xs space-y-4">
              <h3 className="font-bold text-blue-400 border-b border-[#2A3B5C] pb-2 flex items-center gap-2">
                <FaBuilding /> Full Company & Business Details
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="font-bold text-slate-300 block mb-1">Member Full Name *</label>
                  <input
                    type="text"
                    value={profileForm.name || ''}
                    onChange={(e) => setProfileForm({ ...profileForm, name: e.target.value })}
                    className="w-full p-2.5 bg-[#131E32] border border-[#2A3B5C] rounded-lg outline-none font-bold text-white focus:border-[#FDBC12]"
                    required
                  />
                </div>

                <div>
                  <label className="font-bold text-slate-300 block mb-1">Company Name</label>
                  <input
                    type="text"
                    value={profileForm.company_name || ''}
                    onChange={(e) => setProfileForm({ ...profileForm, company_name: e.target.value })}
                    placeholder="e.g. Acme Logistics Pvt Ltd"
                    className="w-full p-2.5 bg-[#131E32] border border-[#2A3B5C] rounded-lg outline-none text-white font-semibold focus:border-[#FDBC12]"
                  />
                </div>

                <div>
                  <label className="font-bold text-slate-300 block mb-1">Company Website</label>
                  <input
                    type="text"
                    value={profileForm.company_website || ''}
                    onChange={(e) => setProfileForm({ ...profileForm, company_website: e.target.value })}
                    placeholder="https://mycompany.com"
                    className="w-full p-2.5 bg-[#131E32] border border-[#2A3B5C] rounded-lg outline-none text-white focus:border-[#FDBC12]"
                  />
                </div>

                <div>
                  <label className="font-bold text-slate-300 block mb-1">Social Media Links</label>
                  <input
                    type="text"
                    value={profileForm.social || ''}
                    onChange={(e) => setProfileForm({ ...profileForm, social: e.target.value })}
                    placeholder="LinkedIn / Instagram / Facebook URL"
                    className="w-full p-2.5 bg-[#131E32] border border-[#2A3B5C] rounded-lg outline-none text-white focus:border-[#FDBC12]"
                  />
                </div>

                <div className="md:col-span-2">
                  <label className="font-bold text-slate-300 block mb-1">Company Address & Location</label>
                  <textarea
                    rows={2}
                    value={profileForm.company_address || ''}
                    onChange={(e) => setProfileForm({ ...profileForm, company_address: e.target.value })}
                    placeholder="Enter complete office/factory location address..."
                    className="w-full p-2.5 bg-[#131E32] border border-[#2A3B5C] rounded-lg outline-none text-white focus:border-[#FDBC12]"
                  />
                </div>

                <div className="md:col-span-2">
                  <label className="font-bold text-slate-300 block mb-1">About Company / Business Services</label>
                  <textarea
                    rows={3}
                    value={profileForm.about_company || ''}
                    onChange={(e) => setProfileForm({ ...profileForm, about_company: e.target.value })}
                    placeholder="Describe your core products, business offerings, and target clients..."
                    className="w-full p-2.5 bg-[#131E32] border border-[#2A3B5C] rounded-lg outline-none text-white focus:border-[#FDBC12]"
                  />
                </div>
              </div>
            </div>
          </form>
        )}

        {/* TAB 4: MY ACTIVITY HISTORY */}
        {activeTab === 'My Activity History' && (
          <div className="bg-[#1E2B45] rounded-xl border border-[#2A3B5C] overflow-hidden shadow-lg">
            <div className="p-4 border-b border-[#2A3B5C] bg-[#131E32] flex justify-between items-center">
              <h2 className="font-bold text-white text-sm flex items-center gap-2">
                <FaHistory className="text-[#FDBC12]" /> My Activity Verification History & Earned Points
              </h2>
              <span className="text-xs font-black text-[#0A2451] bg-[#FDBC12] px-3 py-1 rounded-full">
                Earned Points: {userdetails?.point || 0} pts
              </span>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse text-xs">
                <thead className="bg-[#0B1220] text-slate-300 font-bold border-b border-[#2A3B5C] uppercase">
                  <tr>
                    <th className="p-3">Type</th>
                    <th className="p-3">Photo Proof</th>
                    <th className="p-3">Recipient / Member</th>
                    <th className="p-3">Amount / Details</th>
                    <th className="p-3">Date</th>
                    <th className="p-3">Status</th>
                    <th className="p-3">Points</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-[#2A3B5C] text-slate-200">
                  {myActivities.length === 0 ? (
                    <tr>
                      <td colSpan={7} className="p-6 text-center text-slate-400 font-medium">No activity history recorded yet.</td>
                    </tr>
                  ) : (
                    myActivities.map((act) => (
                      <tr key={act.id} className="hover:bg-[#131E32] transition">
                        <td className="p-3 font-bold text-[#FDBC12]">{act.type}</td>
                        <td className="p-3">
                          {act.image ? (
                            <img
                              src={act.image.startsWith('http') ? act.image : `https://rmbbackend.rmbjaipur.com/${act.image}`}
                              alt="Proof"
                              className="h-10 w-10 object-cover rounded border border-[#2A3B5C]"
                            />
                          ) : (
                            <span className="text-slate-500">-</span>
                          )}
                        </td>
                        <td className="p-3 font-semibold text-white">{act.receiver_name || act.ref_person_name || 'Chapter'}</td>
                        <td className="p-3 text-slate-300">
                          {act.amount ? `₹${Number(act.amount).toLocaleString()} ` : ''}
                          {act.details || '-'}
                        </td>
                        <td className="p-3 text-slate-400">{act.date}</td>
                        <td className="p-3">{getStatusBadge(act.status)}</td>
                        <td className="p-3 font-bold text-emerald-400">+{act.points_awarded} pts</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* TAB 5: MY RENEWAL LEDGER */}
        {activeTab === 'My Renewal Ledger' && (
          <div className="bg-[#1E2B45] rounded-xl border border-[#2A3B5C] overflow-hidden shadow-lg">
            <div className="p-4 border-b border-[#2A3B5C] bg-[#131E32]">
              <h2 className="font-bold text-white text-sm flex items-center gap-2">
                <FaCalendarCheck className="text-emerald-400" /> My Membership Renewal & Payment Audit History
              </h2>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse text-xs">
                <thead className="bg-[#0B1220] text-slate-300 font-bold border-b border-[#2A3B5C] uppercase">
                  <tr>
                    <th className="p-3">Action</th>
                    <th className="p-3">Joining Date</th>
                    <th className="p-3">Renewal Date</th>
                    <th className="p-3">Next Expiry Date</th>
                    <th className="p-3">Amount Paid</th>
                    <th className="p-3">Payment Mode & Ref</th>
                    <th className="p-3">Notes</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-[#2A3B5C] text-slate-200">
                  {myAuditLogs.length === 0 ? (
                    <tr>
                      <td colSpan={7} className="p-6 text-center text-slate-400 font-medium">No renewal audit history recorded.</td>
                    </tr>
                  ) : (
                    myAuditLogs.map((item) => (
                      <tr key={item.id} className="hover:bg-[#131E32] transition">
                        <td className="p-3 font-bold text-blue-400">{item.action_type}</td>
                        <td className="p-3 text-slate-400">{item.joining_date ? new Date(item.joining_date).toLocaleDateString() : '-'}</td>
                        <td className="p-3 font-bold text-emerald-400">{new Date(item.renewal_date).toLocaleDateString()}</td>
                        <td className="p-3 font-bold text-amber-400">{new Date(item.next_expiry_date).toLocaleDateString()}</td>
                        <td className="p-3 font-black text-white">₹{Number(item.amount_paid).toLocaleString()}</td>
                        <td className="p-3">
                          <div className="font-bold text-slate-300">{item.payment_mode}</div>
                          {item.payment_reference && <div className="text-[10px] text-slate-400">Ref: {item.payment_reference}</div>}
                        </td>
                        <td className="p-3 text-slate-400 max-w-xs truncate">{item.notes || '-'}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

      </main>

      {/* PUNCH ACTIVITY MODAL */}
      {showPunchModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4">
          <div className="bg-[#1E2B45] border border-[#2A3B5C] rounded-xl max-w-lg w-full p-6 text-slate-100 shadow-2xl space-y-4 max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center border-b border-[#2A3B5C] pb-3">
              <h3 className="font-bold text-white text-base flex items-center gap-2">
                <FaPlus className="text-[#FDBC12]" /> 
                {punchType === 'R2R' && 'Log R2R Meeting (Photo Proof Compulsory)'}
                {punchType === 'BUSINESS' && 'Log Business Closed (TYFCB)'}
                {punchType === 'REFERRAL' && 'Log Referral / Reference Passed'}
                {punchType === 'VISITOR' && 'Log Visitor / Guest Invite'}
                {punchType === 'TESTIMONIAL' && 'Submit Testimonial (Business Giver Only)'}
                {punchType === 'THANK_YOU' && 'Send Thank You Note (Business Receiver Only)'}
                {punchType === 'ATTENDANCE' && 'Punch Event / Meeting Attendance'}
              </h3>
              <button onClick={() => setShowPunchModal(false)} className="text-slate-400 hover:text-white">
                <FaTimes size={18} />
              </button>
            </div>

            <form onSubmit={handlePunchSubmit} className="space-y-4 text-xs">
              
              {/* Photo & Invoice Proof Upload Section for R2R, BUSINESS, VISITOR, ATTENDANCE */}
              {['R2R', 'BUSINESS', 'VISITOR', 'ATTENDANCE'].includes(punchType) && (
                <div className="bg-[#131E32] p-3.5 rounded-lg border border-amber-500/40 space-y-2.5">
                  <label className="font-bold text-amber-300 block flex items-center gap-1.5 text-xs">
                    <FaImage /> 
                    {punchType === 'R2R' && 'R2R Meeting Photo Proof * (COMPULSORY FOR R2R)'}
                    {punchType === 'BUSINESS' && 'Invoice / Bill / Receipt Proof Image (Optional)'}
                    {punchType === 'VISITOR' && 'Visitor Photo / Business Card Image (Optional)'}
                    {punchType === 'ATTENDANCE' && 'Attendance Proof / Event Selfie Image (Optional)'}
                  </label>

                  <div className="flex flex-col sm:flex-row items-center gap-2">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleFileUpload}
                      className="w-full text-xs text-slate-300 file:mr-3 file:py-1.5 file:px-3 file:rounded-lg file:border-0 file:text-xs file:font-bold file:bg-[#FDBC12] file:text-[#0A2451] hover:file:bg-amber-400 cursor-pointer"
                    />
                    {isUploading && <span className="text-amber-400 font-bold text-xs animate-pulse">Uploading...</span>}
                  </div>

                  <input
                    type="text"
                    placeholder={
                      punchType === 'BUSINESS'
                        ? 'Or enter invoice / receipt image URL (e.g. uploads/invoice.jpg)'
                        : punchType === 'VISITOR'
                        ? 'Or enter visitor business card / photo URL'
                        : 'Or enter photo proof URL / path'
                    }
                    value={punchForm.image}
                    onChange={(e) => setPunchForm({ ...punchForm, image: e.target.value })}
                    className="w-full p-2 bg-[#0B1220] border border-amber-400/30 rounded-lg outline-none text-white font-mono text-[11px]"
                    required={punchType === 'R2R'}
                  />

                  {punchForm.image && (
                    <div className="mt-1 flex items-center gap-2 bg-[#0B1220] p-1.5 rounded border border-amber-400/30">
                      <img
                        src={punchForm.image.startsWith('http') ? punchForm.image : `https://rmbbackend.rmbjaipur.com/${punchForm.image}`}
                        alt="Preview"
                        className="h-10 w-10 object-cover rounded border"
                      />
                      <span className="text-[10px] text-emerald-400 font-bold">
                        ✓ {punchType === 'BUSINESS' ? 'Invoice Proof Attached' : punchType === 'VISITOR' ? 'Visitor Image Attached' : 'Photo Attached'}
                      </span>
                    </div>
                  )}
                </div>
              )}

              {/* Attendance Admin Verification Subject Notice Banner */}
              {punchType === 'ATTENDANCE' && (
                <div className="p-3 bg-amber-950/40 border border-amber-500/40 rounded-xl text-amber-200 text-xs flex items-start gap-2">
                  <span className="text-base">⏳</span>
                  <div>
                    <strong className="block font-bold text-amber-300">Admin Approval Required</strong>
                    Attendance recorded from member portal is submitted with status <span className="underline font-bold">PENDING VERIFICATION</span>. It will be reviewed and verified by Chapter Admin before leaderboard attendance points are credited.
                  </div>
                </div>
              )}

              {/* Select Event Dropdown (WILL NOT SHOW FOR TESTIMONIAL OR THANK YOU NOTE) */}
              {punchType !== 'TESTIMONIAL' && punchType !== 'THANK_YOU' && (
                <div>
                  <label className="font-bold text-slate-300 block mb-1 flex items-center justify-between">
                    <span>Select Event (Optional)</span>
                    <span className="text-[10px] text-[#FDBC12] font-normal">Events created in News / Meetings</span>
                  </label>
                  <select
                    value={punchForm.event_id || ''}
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      const found = createdEventsList.find((ev: any) => String(ev.id) === selectedId);
                      setPunchForm({
                        ...punchForm,
                        event_id: selectedId,
                        details: found ? found.title : punchForm.details,
                        date: found && found.date ? found.date.split('T')[0] : punchForm.date
                      });
                    }}
                    className="w-full p-2.5 bg-[#131E32] border border-[#2A3B5C] focus:border-[#FDBC12] rounded-lg outline-none font-bold text-white text-xs"
                  >
                    <option value="">-- Choose Created Event from News (Optional) --</option>
                    {createdEventsList.map((ev: any) => (
                      <option key={ev.id} value={ev.id}>
                        {ev.title} ({ev.date ? new Date(ev.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : 'Event'})
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {/* TESTIMONIAL SPECIFIC: Select Closed Business Transaction (Giver Only) */}
              {punchType === 'TESTIMONIAL' && (
                <div className="space-y-2">
                  <label className="font-bold text-[#FDBC12] block">
                    Select Closed Business Transaction (You Were Giver) *
                  </label>
                  {closedBusinessGiveness.length === 0 ? (
                    <div className="p-3 bg-amber-950/40 border border-amber-500/40 rounded-lg text-amber-300 text-xs">
                      ⚠️ You have not given any business transactions yet. Testimonials can only be shared for business transactions where you were the Giver.
                    </div>
                  ) : (
                    <select
                      value={selectedClosedBusinessId}
                      onChange={(e) => {
                        const id = e.target.value;
                        setSelectedClosedBusinessId(id);
                        const match = closedBusinessGiveness.find(b => String(b.id) === id);
                        if (match) {
                          setPunchForm({
                            ...punchForm,
                            receiver_id: match.receiver_id || '',
                            amount: match.amount || '',
                            date: match.date || punchForm.date
                          });
                        }
                      }}
                      className="w-full p-2.5 bg-[#131E32] border border-[#2A3B5C] rounded-lg outline-none font-bold text-white text-xs"
                      required
                    >
                      <option value="">-- Select Closed Business Transaction --</option>
                      {closedBusinessGiveness.map((b) => (
                        <option key={b.id} value={b.id}>
                          To: {b.receiver_name || `Member #${b.receiver_id}`} | ₹{Number(b.amount || 0).toLocaleString()} ({b.date})
                        </option>
                      ))}
                    </select>
                  )}
                </div>
              )}

              {/* THANK YOU NOTE SPECIFIC: Select Closed Business Transaction (Receiver Only) */}
              {punchType === 'THANK_YOU' && (
                <div className="space-y-2">
                  <label className="font-bold text-rose-300 block">
                    Select Closed Business Transaction (You Were Receiver) *
                  </label>
                  {closedBusinessReceives.length === 0 ? (
                    <div className="p-3 bg-rose-950/40 border border-rose-500/40 rounded-lg text-rose-300 text-xs">
                      ⚠️ You have not received any business transactions yet. Thank You Notes can only be shared for business transactions where you were the Receiver.
                    </div>
                  ) : (
                    <select
                      value={selectedClosedBusinessId}
                      onChange={(e) => {
                        const id = e.target.value;
                        setSelectedClosedBusinessId(id);
                        const match = closedBusinessReceives.find(b => String(b.id) === id);
                        if (match) {
                          setPunchForm({
                            ...punchForm,
                            receiver_id: match.giver_id || '', // Giver receives thank you
                            amount: match.amount || '',
                            date: match.date || punchForm.date
                          });
                        }
                      }}
                      className="w-full p-2.5 bg-[#131E32] border border-[#2A3B5C] rounded-lg outline-none font-bold text-white text-xs"
                      required
                    >
                      <option value="">-- Select Closed Business Transaction --</option>
                      {closedBusinessReceives.map((b) => (
                        <option key={b.id} value={b.id}>
                          From: {b.giver_name || `Member #${b.giver_id}`} | ₹{Number(b.amount || 0).toLocaleString()} ({b.date})
                        </option>
                      ))}
                    </select>
                  )}
                </div>
              )}

              {/* Date & Location Fields */}
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="font-bold text-slate-300 block mb-1">Meeting / Transaction Date *</label>
                  <input
                    type="date"
                    value={punchForm.date}
                    onChange={(e) => setPunchForm({ ...punchForm, date: e.target.value })}
                    className="w-full p-2.5 bg-[#131E32] border border-[#2A3B5C] rounded-lg outline-none font-bold text-white"
                    required
                  />
                </div>
                <div>
                  <label className="font-bold text-slate-300 block mb-1">Location / Venue</label>
                  <input
                    type="text"
                    value={punchForm.location}
                    onChange={(e) => setPunchForm({ ...punchForm, location: e.target.value })}
                    placeholder="e.g. Hotel Marriott / Member Office"
                    className="w-full p-2.5 bg-[#131E32] border border-[#2A3B5C] rounded-lg outline-none text-white"
                  />
                </div>
              </div>

              {/* Member Selection for R2R & Business */}
              {['R2R', 'BUSINESS'].includes(punchType) && (
                <div>
                  <label className="font-bold text-slate-300 block mb-1">
                    Select RMB Member {punchType === 'R2R' ? '(R2R Done With) *' : '*'}
                  </label>
                  <select
                    value={punchForm.receiver_id}
                    onChange={(e) => setPunchForm({ ...punchForm, receiver_id: e.target.value })}
                    className="w-full p-2.5 bg-[#131E32] border border-[#2A3B5C] rounded-lg outline-none font-bold text-white"
                    required
                  >
                    <option value="">Select Member</option>
                    {allMembers.map((m) => (
                      <option key={m.id} value={m.id}>{m.name} {m.company_name ? `(${m.company_name})` : ''}</option>
                    ))}
                  </select>
                </div>
              )}

              {/* Referral / Visitor Inputs */}
              {['REFERRAL', 'VISITOR'].includes(punchType) && (
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="font-bold text-slate-300 block mb-1">
                      {punchType === 'VISITOR' ? 'Visitor / Guest Name *' : 'Referred Person Name *'}
                    </label>
                    <input
                      type="text"
                      value={punchForm.ref_person_name}
                      onChange={(e) => setPunchForm({ ...punchForm, ref_person_name: e.target.value })}
                      placeholder={punchType === 'VISITOR' ? 'Full Visitor Name' : 'Full Name'}
                      className="w-full p-2.5 bg-[#131E32] border border-[#2A3B5C] focus:border-[#FDBC12] rounded-lg outline-none text-white font-bold"
                      required
                    />
                  </div>
                  <div>
                    <label className="font-bold text-slate-300 block mb-1">
                      {punchType === 'VISITOR' ? 'Visitor Contact Number *' : 'Contact Number *'}
                    </label>
                    <input
                      type="text"
                      value={punchForm.number}
                      onChange={(e) => setPunchForm({ ...punchForm, number: e.target.value })}
                      placeholder="Mobile / Phone number"
                      className="w-full p-2.5 bg-[#131E32] border border-[#2A3B5C] focus:border-[#FDBC12] rounded-lg outline-none text-white font-bold"
                      required
                    />
                  </div>
                </div>
              )}

              {/* Amount for Business */}
              {['BUSINESS'].includes(punchType) && (
                <div>
                  <label className="font-bold text-slate-300 block mb-1">Business Amount (₹, optional)</label>
                  <input
                    type="number"
                    value={punchForm.amount}
                    onChange={(e) => setPunchForm({ ...punchForm, amount: e.target.value })}
                    placeholder="e.g. 50000"
                    className="w-full p-2.5 bg-[#131E32] border border-[#2A3B5C] rounded-lg outline-none text-white font-bold"
                  />
                </div>
              )}

              {/* Description / Notes */}
              <div>
                <label className="font-bold text-slate-300 block mb-1">
                  {punchType === 'R2R' ? 'Meeting Description / Discussion Topics (Optional)' : punchType === 'TESTIMONIAL' ? 'Testimonial Details *' : punchType === 'THANK_YOU' ? 'Thank You Message *' : 'Description / Notes'}
                </label>
                <textarea
                  value={punchForm.details}
                  onChange={(e) => setPunchForm({ ...punchForm, details: e.target.value })}
                  placeholder="Enter notes or details..."
                  className="w-full p-2.5 bg-[#131E32] border border-[#2A3B5C] rounded-lg outline-none text-white h-24"
                  required={['TESTIMONIAL', 'THANK_YOU'].includes(punchType)}
                />
              </div>

              <div className="flex justify-end gap-2 border-t border-[#2A3B5C] pt-3">
                <button
                  type="button"
                  onClick={() => setShowPunchModal(false)}
                  className="px-4 py-2 bg-[#131E32] text-slate-300 hover:text-white rounded-lg text-xs font-bold"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={(punchType === 'TESTIMONIAL' && closedBusinessGiveness.length === 0) || (punchType === 'THANK_YOU' && closedBusinessReceives.length === 0)}
                  className="px-5 py-2 bg-[#FDBC12] hover:bg-amber-400 text-[#0A2451] font-black text-xs rounded-lg shadow cursor-pointer disabled:opacity-50"
                >
                  Submit Activity
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* NATIVE MOBILE APP BOTTOM NAVIGATION BAR (As per screenshot) */}
      <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-[#0B1220] border-t border-[#2A3B5C] shadow-2xl">
        <div className="grid grid-cols-5 items-center h-16 max-w-md mx-auto px-1">
          {/* 1. Dashboard */}
          <button
            type="button"
            onClick={() => setActiveTab('Dashboard')}
            className={`flex flex-col items-center justify-center py-1 transition cursor-pointer relative ${
              activeTab === 'Dashboard' ? 'text-[#FDBC12] font-black' : 'text-slate-400 hover:text-white'
            }`}
          >
            <FaThLarge size={18} />
            <span className="text-[10px] mt-1 font-bold">Dashboard</span>
            {activeTab === 'Dashboard' && <span className="absolute bottom-0 left-2 right-2 h-0.5 bg-[#FDBC12] rounded-full" />}
          </button>

          {/* 2. Events */}
          <button
            type="button"
            onClick={() => setActiveTab('Events & Calendar')}
            className={`flex flex-col items-center justify-center py-1 transition cursor-pointer relative ${
              activeTab === 'Events & Calendar' ? 'text-[#FDBC12] font-black' : 'text-slate-400 hover:text-white'
            }`}
          >
            <FaCalendarAlt size={18} />
            <span className="text-[10px] mt-1 font-bold">Events</span>
            {activeTab === 'Events & Calendar' && <span className="absolute bottom-0 left-2 right-2 h-0.5 bg-[#FDBC12] rounded-full" />}
          </button>

          {/* 3. Activity */}
          <button
            type="button"
            onClick={() => setActiveTab('My Activity History')}
            className={`flex flex-col items-center justify-center py-1 transition cursor-pointer relative ${
              activeTab === 'My Activity History' ? 'text-[#FDBC12] font-black' : 'text-slate-400 hover:text-white'
            }`}
          >
            <FaHistory size={18} />
            <span className="text-[10px] mt-1 font-bold">Activity</span>
            {activeTab === 'My Activity History' && <span className="absolute bottom-0 left-2 right-2 h-0.5 bg-[#FDBC12] rounded-full" />}
          </button>

          {/* 4. Ledger */}
          <button
            type="button"
            onClick={() => setActiveTab('My Renewal Ledger')}
            className={`flex flex-col items-center justify-center py-1 transition cursor-pointer relative ${
              activeTab === 'My Renewal Ledger' ? 'text-[#FDBC12] font-black' : 'text-slate-400 hover:text-white'
            }`}
          >
            <FaCalendarCheck size={18} />
            <span className="text-[10px] mt-1 font-bold">Ledger</span>
            {activeTab === 'My Renewal Ledger' && <span className="absolute bottom-0 left-2 right-2 h-0.5 bg-[#FDBC12] rounded-full" />}
          </button>

          {/* 5. Profile */}
          <button
            type="button"
            onClick={() => setActiveTab('My Profile & Credentials')}
            className={`flex flex-col items-center justify-center py-1 transition cursor-pointer relative ${
              activeTab === 'My Profile & Credentials' ? 'text-[#FDBC12] font-black' : 'text-slate-400 hover:text-white'
            }`}
          >
            <FaUser size={18} />
            <span className="text-[10px] mt-1 font-bold">Profile</span>
            {activeTab === 'My Profile & Credentials' && <span className="absolute bottom-0 left-2 right-2 h-0.5 bg-[#FDBC12] rounded-full" />}
          </button>
        </div>
      </nav>
      </div>

      {/* MEMBER RESET PASSWORD MODAL */}
      {showResetPasswordModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/75 backdrop-blur-xs animate-fade-in">
          <div className="bg-[#131E32] text-slate-100 rounded-3xl p-6 sm:p-8 max-w-md w-full shadow-2xl border border-[#2A3B5C] space-y-5 relative">
            <button
              type="button"
              onClick={() => {
                setShowResetPasswordModal(false);
                setResetPasswordMessage({ type: '', text: '' });
                setNewMemberPassword('');
                setConfirmMemberPassword('');
              }}
              className="absolute top-5 right-5 text-slate-400 hover:text-white text-xl font-bold cursor-pointer"
            >
              ✕
            </button>

            <div className="text-center space-y-1">
              <div className="w-14 h-14 bg-amber-500/20 text-[#FDBC12] rounded-2xl mx-auto flex items-center justify-center text-2xl shadow-inner border border-amber-400/30 mb-3">
                🔑
              </div>
              <h2 className="text-xl font-black text-white">Reset Account Password</h2>
              <p className="text-xs text-slate-400">
                Member: <strong className="text-white">{userdetails?.name}</strong>. Enter your new account password below.
              </p>
            </div>

            {resetPasswordMessage.text && (
              <div className={`p-3 rounded-xl text-xs font-semibold text-center border ${
                resetPasswordMessage.type === 'error' ? 'bg-red-950/80 border-red-500/40 text-red-200' : 'bg-emerald-950/80 border-emerald-500/40 text-emerald-200'
              }`}>
                {resetPasswordMessage.text}
              </div>
            )}

            <form
              onSubmit={async (e) => {
                e.preventDefault();
                setResetPasswordMessage({ type: '', text: '' });
                if (newMemberPassword !== confirmMemberPassword) {
                  setResetPasswordMessage({ type: 'error', text: 'Passwords do not match. Please check both fields.' });
                  return;
                }
                setResetPasswordLoading(true);
                try {
                  const res = await axios.post('https://rmbbackend.rmbjaipur.com/auth/member/change-password', {
                    user_id: userdetails?.id,
                    newPassword: newMemberPassword
                  });
                  if (res.data.success) {
                    setResetPasswordMessage({ type: 'success', text: res.data.message || 'Password updated successfully!' });
                    setUserdetails((prev: any) => ({ ...prev, plain_password: newMemberPassword, password: newMemberPassword }));
                    setTimeout(() => {
                      setShowResetPasswordModal(false);
                      setNewMemberPassword('');
                      setConfirmMemberPassword('');
                      setResetPasswordMessage({ type: '', text: '' });
                    }, 1800);
                  }
                } catch (err: any) {
                  setResetPasswordMessage({ type: 'error', text: err.response?.data?.error || 'Failed to update password.' });
                } finally {
                  setResetPasswordLoading(false);
                }
              }}
              className="space-y-4"
            >
              <div>
                <label className="block text-xs font-extrabold uppercase tracking-wider text-slate-300 mb-1">
                  New Password *
                </label>
                <input
                  type="password"
                  value={newMemberPassword}
                  onChange={(e) => setNewMemberPassword(e.target.value)}
                  placeholder="Enter new password (min 4 chars)"
                  className="w-full px-4 py-3 bg-[#0B1220] border border-[#2A3B5C] rounded-xl text-sm font-semibold text-amber-300 font-mono outline-none focus:border-[#FDBC12]"
                  required
                />
              </div>

              <div>
                <label className="block text-xs font-extrabold uppercase tracking-wider text-slate-300 mb-1">
                  Confirm New Password *
                </label>
                <input
                  type="password"
                  value={confirmMemberPassword}
                  onChange={(e) => setConfirmMemberPassword(e.target.value)}
                  placeholder="Re-enter new password"
                  className="w-full px-4 py-3 bg-[#0B1220] border border-[#2A3B5C] rounded-xl text-sm font-semibold text-amber-300 font-mono outline-none focus:border-[#FDBC12]"
                  required
                />
              </div>

              <div className="flex justify-end gap-2 pt-2">
                <button
                  type="button"
                  onClick={() => setShowResetPasswordModal(false)}
                  className="px-4 py-2.5 bg-slate-800 hover:bg-slate-700 text-slate-300 font-bold text-xs rounded-xl cursor-pointer"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={resetPasswordLoading}
                  className="px-5 py-2.5 bg-[#FDBC12] hover:bg-amber-400 text-[#0A2451] font-black text-xs rounded-xl shadow-lg transition cursor-pointer disabled:opacity-50"
                >
                  {resetPasswordLoading ? 'Saving...' : '🔑 Update Password'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default MemberPortal;
